import { TextareaAutosize } from '@mui/material';
import { useEffect, useState } from 'react';
import { Modal, IModal, useNotification } from '../../components';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useSalonStore } from '../../store';

const NotesModal = ({ open, handleClose }: IModal) => {
  const { t } = useTranslation();
  const { salonId } = useParams();
  const navigate = useNavigate();

  const { salon, updateNotes } = useSalonStore();
  const { showMessage } = useNotification();
  const [draftText, setDraftText] = useState<string | null>(salon?.notes || null);

  useEffect(() => {
    setDraftText(salon?.notes);
  }, [salon?.notes]);

  const handleSaveBtn = () => {
    handleClose();
    updateNotes(salonId, draftText, showMessage, navigate);
  };

  const handleCloseBtn = () => {
    handleClose();
    setDraftText(salon?.notes);
  };

  const content = () => (
    <TextareaAutosize
      maxRows={15}
      minRows={10}
      placeholder={t('addNotes')}
      defaultValue={salon?.notes}
      value={draftText}
      onChange={(e) => setDraftText(e.target.value)}
      style={{
        minWidth: '100%',
        fontSize: '16px',
      }}
    />
  );

  return (
    <Modal
      open={open}
      fullWidth={true}
      maxWidth="md"
      handleClose={handleCloseBtn}
      header="Notes"
      mainContent={content()}
      isSaveButton
      handleSave={handleSaveBtn}
    />
  );
};

export default NotesModal;
